import { createAction, props } from '@ngrx/store';

import {
  Application,
  ApplicationGroup,
  NewRole,
} from '../../../shared/models/authorizationService.model';

export const getApplicationGroups = createAction('[App-Wizard] Get application groups');

export const getApplicationGroupsSuccess = createAction(
  '[App-Wizard] Get application groups success',
  props<{ applicationGroups: ApplicationGroup[] }>(),
);

export const getApplications = createAction('[App-Wizard] Get applications');

export const getApplicationsSuccess = createAction(
  '[App-Wizard] Get applications success',
  props<{ applications: Application[] }>(),
);

export const getApplicationRoles = createAction('[App-Wizard] Get application roles');

export const getApplicationRolesSuccess = createAction(
  '[App-Wizard] Get application roles success',
  props<{ roles: NewRole[] }>(),
);

export const createNewApplication = createAction(
  '[App-Wizard] Create New Application',
  props<{ newApplication: Application }>(),
);

export const createNewApplicationGroup = createAction(
  '[App-Wizard] Create New ApplicationGroup',
  props<{ newApplicationGroup: ApplicationGroup }>(),
);

export const deleteApplicationGroup = createAction(
  '[App-Wizard] Delete ApplicationGroup',
  props<{ id: number }>(),
);

export const deleteApplicationGroupSuccess = createAction(
  '[App-Wizard] Delete ApplicationGroup Success',
  props<{ id: number }>(),
);

export const deleteApplicationGroupError = createAction(
  '[App-Wizard] Delete ApplicationGroup Error',
  props<{ error: Error }>(),
);

export const deleteApplication = createAction(
  '[App-Wizard] Delete Application',
  props<{ key: string }>(),
);

export const deleteApplicationSuccess = createAction(
  '[App-Wizard] Delete Application Success',
  props<{ key: string }>(),
);

export const deleteApplicationError = createAction(
  '[App-Wizard] Delete Application Error',
  props<{ error: Error }>(),
);
